module.exports = __webpack_public_path__ + "static/media/999games.6bb8877f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/999games.webp
// module id = 601
// module chunks = 0